const SDK_VERSION = "10.76.1" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
